import type { useSingleton } from "@tippyjs/react";
import { useAtomValue } from "jotai";
import { canv } from "@/canv/global";
import { MinusIcon, PlusIcon } from "@/icons";
import { zoomAtom } from "@/interface/AppStore";
import { Tooltip } from "@/interface/ui/Tooltip";
import { BottomBarItem } from "../BottomBarItem";
import styles from "./ZoomControls.module.css";

export const ZoomControls = ({
    singletonTarget,
}: {
    singletonTarget: ReturnType<typeof useSingleton>[1];
}) => {
    const zoom = useAtomValue(zoomAtom);
    const handleMinus = () => {
        canv.actionManager.zoomMinus();
    };
    const handlePlus = () => {
        canv.actionManager.zoomPlus();
    };
    return (
        <>
            <Tooltip
                content="Отдалить"
                hotkey={`${canv.actionManager.actionSymbol} -`}
                singleton={singletonTarget}
            >
                <BottomBarItem onClick={handleMinus}>
                    <MinusIcon />
                </BottomBarItem>
            </Tooltip>
            <Tooltip content="Масштаб" singleton={singletonTarget}>
                <BottomBarItem className={styles.zoomValue} as="span">
                    {zoom}%
                </BottomBarItem>
            </Tooltip>
            <Tooltip
                content="Приблизить"
                hotkey={`${canv.actionManager.actionSymbol} +`}
                singleton={singletonTarget}
            >
                <BottomBarItem onClick={handlePlus}>
                    <PlusIcon />
                </BottomBarItem>
            </Tooltip>
        </>
    );
};
